import { Routes } from '@angular/router';
import {
  CmsPageComponent,
  cmsPageTemplateResolver,
  cmsSeoDataResolver,
} from '@domgen/dgx-fe-cms';

export const CONTENT_ROUTES: Routes = [
  {
    path: '',
    component: CmsPageComponent,
    data: {
      gaData: {
        eventCategory: 'support-pages',
      },
    },
    resolve: {
      cmsPageTemplate: cmsPageTemplateResolver,
      seoData: cmsSeoDataResolver,
    },
  },
];
